import { defineMessages } from 'react-intl';

export default defineMessages({
  availableLabel: {
    id: 'sku-availability-toggle--available',
    defaultMessage: 'Available',
  },
  unavailableLabel: {
    id: 'sku-availability-toggle--unavailable',
    defaultMessage: 'Unavailable',
  },
});
